import type { ReactNode, RefObject } from "react";

import { Box, Flex, Spinner, StackSeparator, VStack } from "@chakra-ui/react";

import { Typography } from "@shared/ui/chakra/typography/typography";

type Props = {
  children: ReactNode;
  hasIcons?: boolean;
  loadMoreRef?: RefObject<HTMLDivElement | null>;
  title?: string;
  titleColor?: string;
  isLoading?: boolean;
};

export const CellPanel = ({
  children,
  hasIcons = true,
  loadMoreRef,
  title,
  titleColor = "text.fg_subtle",
  isLoading,
}: Props) => {
  return (
    <VStack alignItems="stretch">
      {title && (
        <Typography color={titleColor} textStyle="label">
          {title}
        </Typography>
      )}
      <VStack alignItems="stretch" gap="0">
        <VStack
          bg="bg.panel"
          borderRadius="2xl"
          gap={0}
          overflow="hidden"
          separator={
            <StackSeparator
              color="border.subtle"
              left={hasIcons ? "50px" : "4"}
              position="relative"
            />
          }
        >
          {children}
        </VStack>
        <Box ref={loadMoreRef} />
      </VStack>
      {isLoading && (
        <Flex
          alignItems="center"
          flexDirection="column"
          justifyContent="space-between"
          py="12"
        >
          <Spinner />
        </Flex>
      )}
    </VStack>
  );
};
